import { config } from "./config";

const InstitutionWorkersGroupsList = () => import("@/components/Module/List.vue");
const InstitutionWorkersGroup = () => import("./views/InstitutionWorkersGroup.vue");
const InstitutionWorkersGroupEdit = () => import("./views/InstitutionWorkersGroupEdit.vue");

export default [
  {
    path: config.route,
    name: `${config.name}.list`,
    component: InstitutionWorkersGroupsList,

    props: {
      config,
    },

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${config.route}/create`,
    name: `${config.name}.create`,
    component: InstitutionWorkersGroupEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${config.route}/:itemId`,
    name: `${config.name}.details`,
    component: InstitutionWorkersGroup,

    props: (route) => ({
      itemId: +route.params.itemId,
    }),

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${config.route}/:itemId/edit`,
    name: `${config.name}.edit`,
    component: InstitutionWorkersGroupEdit,

    props: (route) => ({
      itemId: +route.params.itemId,
    }),

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
